//packages blocks
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { SchoolOutlined } from "@material-ui/icons";
import { Box, Typography } from "@material-ui/core";
import { useHistory, withRouter } from "react-router";
import { useDispatch, useSelector } from "react-redux";
//common blocks
import "./styles.css";
//styles, utils, assets and api blocks
import { getAllSchools } from "../../../api/schools";
import { logout } from "../../../redux/reducers/user";
import { setAlert } from "../../../redux/reducers/alert";
import { BLACK, BLUE_EIGHT, GREY_SEVENTEEN } from "../../../theme";
import whiteLogo from "../../../assets/images/logo-v1.png";

const Side = () => {
  const [selectedPage, setSelected] = useState("dashboard");
  const history = useHistory();
  const path = document.location.pathname;
  const dispatch = useDispatch();
  const { role, id, schoolId } = useSelector((state) => state.user);
  const { token } = useSelector((state) => state.user);
  const [schoolName, setschoolName] = useState('');
  const [isEnglish, setIsEnglish] = useState(true);
  const [isArabic, setIsArabic] = useState(false);

  const { t, i18n } = useTranslation();

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);

      if (response.status) {
        setschoolName(response?.schools[0]?.name);
      }
    } catch (e) {
    }
  };
  localStorage.setItem('school-name', role === 'superadmin' ? t("text_school_fee_management_dashboard") : schoolName);
  useEffect(() => {
    fetchSchools();
    if (path === "/") setSelected("dashboard");
    else if (path === "/students") setSelected("students");
    else if (path === "/balances") setSelected("balances");
    else if (path === "/users" || path.includes("users"))
      setSelected("usersManagement");
    else if (path === "/schools") setSelected("schoolManagement");
    else if (path === "/accounts" || path.includes("accounts")) setSelected("accounts");
    else if (path === "/transactions" || path.includes("transactions"))
      setSelected("recentTransactions");
    else if (path === "/settings") setSelected("settings");
  }, [setSelected, path]);

  const clickLink = (url) => {
    if (url === "logout") {
      dispatch(logout(null));
      localStorage.setItem("notify", JSON.stringify(null));
      history.push("/");
      showSuccessAlert("logout Successfully!");
      return;
    }
    history.push(url);
  };

  const changeLanguage = (lng) => {
    if (lng === "en") {
      setIsEnglish(true)
      setIsArabic(false)
    } else {
      setIsArabic(true)
      setIsEnglish(false)
    }

    i18n.changeLanguage(lng);
  };

  return (
    <>
      <div className="sidebar" activeKey="/home">
        <div className="brand_img">
          <img src={whiteLogo} />
        </div>

        <div className="sidebar-inner-container">
          <div>
            <div
              className="menu_options"
            >
              <MenuOption
                icon={<div className="menu_options_icon dashboard_icon"></div>}
                id={"dashboard"}
                path={"/"}
                name={t("text_dashboard")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />

              <MenuOption
                icon={<div className="menu_options_icon student_management_icon"></div>}
                id={"students"}
                path={"/students"}
                name={t("text_students")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />

              <MenuOption
                icon={<div className="menu_options_icon balance_management_icon"></div>}
                id={"balances"}
                path={"/balances"}
                name={t("text_balances")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />

              <MenuOption
                icon={
                  <div className="menu_options_icon user_management_icon"></div>
                }
                id={"usersManagement"}
                path={"/users"}
                name={t("text_users")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />

              {role === "superadmin" ? (
                <MenuOption
                  icon={<div className="menu_options_icon school_icon"></div>}

                  id={"schoolManagement"}
                  path={"/schools"}
                  name={t("text_schools")}
                  subMenus={[]}
                  clickLink={clickLink}
                  selectedPage={selectedPage}
                />
              ) : (
                <></>
              )}

              {false && (
                <MenuOption
                  icon={<div className="menu_options_icon bank_icon"></div>}
                  id={"accounts"}
                  path={"/accounts"}
                  name={t("text_accounts")}
                  subMenus={[]}
                  clickLink={clickLink}
                  selectedPage={selectedPage}
                />
              )}

              <MenuOption
                icon={<div className="menu_options_icon transaction_icon"></div>}
                id={"recentTransactions"}
                path={"/transactions"}
                name={t("text_transactions")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />

              <MenuOption
                icon={<div className="menu_options_icon setting_icon"></div>}
                id={"settings"}
                path={"/settings"}
                name={t("text_settings")}
                subMenus={[]}
                clickLink={clickLink}
                selectedPage={selectedPage}
              />
            </div>
          </div>

          <div>
            <Box
              key={id}
              className="logout-container"
              style={{
                fontFamily: "SfProDisplay-regular",
              }}
              onClick={() => clickLink("logout")}
            >
              <div className="logout_icon"></div>
              <Typography variant="h3" mb={2}>
                {t("text_logout")}
              </Typography>
            </Box>

            <Box display="flex" ml={5}>
              <Typography variant="h3" style={{ color: isEnglish ? BLACK : GREY_SEVENTEEN, cursor: "pointer", borderRight: `2px solid ${BLUE_EIGHT}`, paddingRight: 5 }} onClick={() => changeLanguage("en")}>
                {t("text_english")}
              </Typography>

              <Typography variant="h3" style={{ color: isArabic ? BLACK : GREY_SEVENTEEN, cursor: "pointer", marginLeft: 5 }} onClick={() => changeLanguage("ar")}>
                {t("text_arabic")}
              </Typography>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

const MenuOption = ({
  id,
  name,
  clickLink,
  path,
  selectedPage,
  subMenus,
  icon,
}) => {

  return (
    <div
      key={id}
      className={`sidebar-text${selectedPage === id || subMenus.indexOf(selectedPage) > -1
        ? "-selected"
        : ""
        }`}
      onClick={() => clickLink(path)}
    >
      {icon}
      <Typography variant="h5" style={{ fontSize: "0.83vw", fontWeight: 600 }}>
        {name}
      </Typography>
    </div>
  );
};

export const Sidebar = withRouter(Side);
